import { extractValue, findSelectOption } from "../../../../../libs/utils";
import { rentTypeOptions } from "../AddPlanComm";
import type { PlanFieldItem } from "./year-card/YearCard";

/** Tracks which lease (TOR) type payment plans were configured for. */
export const PAYMENT_PLAN_TOR_TYPE_KEY = "paymentPlanTorType";

export function shouldResetPaymentPlansForTorTypeChange(
  paymentPlanTorType: string | undefined | null,
  currentTorType: string | undefined,
): boolean {
  if (paymentPlanTorType == null || currentTorType == null) return false;
  return paymentPlanTorType !== currentTorType;
}

export function getClearedCommercialPaymentPlanBookingFormPatch() {
  return {
    commercialPaymentPlan: [] as [],
    paymentPlan: [] as [],
    commercialBillingScheduleBreakdown: [] as [],
  };
}

export function mapFormPlansToCommercialPaymentPlan(plans: PlanFieldItem[]) {
  return plans.map((item, index) => ({
    ...item,
    noOfYear: item?.noOfYear ?? index + 1,
    installments: extractValue(item?.installments),
    rentType: extractValue(item?.rentType),
    torPeriod: extractValue(item?.torPeriod),
  }));
}

export function createEmptyCommercialPlanField(isTurnoverRentOnly: boolean) {
  const emptyPlan = {
    billingScheduleRows: undefined,
    serviceCharge: undefined,
    serviceChargeSchedule: undefined,
  };

  if (!isTurnoverRentOnly) return emptyPlan;

  return {
    ...emptyPlan,
    rentType: findSelectOption(rentTypeOptions, "fixed"),
    annualRent: 0,
    installments: null,
  };
}
